import React, { useEffect, useState } from "react";
import "../UserFormula/userformula.css";

import Confirm from "../../../../../Components/Popups/Confirm";
import Loader from "../../../../../Components/CircularLoader/CircularLoader";
import CarrierInnerTableLoader from "../../../../../Components/CarrierInnerTableLoader/CarrierInnerTableLoader";

import {
  getMarkupFormula,
  createUserPaymentFormula,
  updateUserPaymentFormula,
} from "../../../../../services/AdminServices/PaymentsAdmin/payments.services";

import { MdAdd } from "react-icons/md";
import Sad from "@mui/icons-material/SentimentVeryDissatisfied";
import Form from "react-bootstrap/Form";
import TextFeild from "../CustomTextFeild/TextFeild";
import { useTranslation } from "react-i18next";

const UserMarkup = ({ setSnack, user, setOpen, updateIndex }) => {
  const { t } = useTranslation("admin");
  const [loading, setLoading] = useState(false);
  const [paymentFormula, setPaymentFormula] = useState(null);
  const [isEditable, setIsEditable] = useState(false);

  const getFormulaData = async () => {
    setLoading("main");
    let response = await getMarkupFormula();
    if (response.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: response?.error?.response?.data?.message,
          severity: "error",
        };
      });
      setLoading(false);
    } else {
      setPaymentFormula(response?.data?.result);
      setIsEditable(false);
      setLoading(false);
    }
  };

  const createFormula = () => {
    setIsEditable(true);
    setPaymentFormula({
      type: "by_markup",
      formula_details: [
        {
          min: null,
          max: null,
          value: "",
        },
      ],
    });
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setIsEditable(true);
    getFormulaData();
  };

  const handleMarkup = (e) => {
    const updatedValue = e.target.value;
    setPaymentFormula((prevState) => ({
      ...prevState,
      formula_details: prevState.formula_details.map((detail, index) =>
        index === 0 ? { ...detail, value: updatedValue } : detail
      ),
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    setLoading("button");
    let response = await createUserPaymentFormula({
      type: paymentFormula?.type,
      formulaDetails: paymentFormula?.formula_details,
    });
    if (response.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: response?.error?.response?.data?.message,
          severity: "error",
        };
      });
      setLoading(false);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: response?.data?.message,
          severity: "success",
        };
      });
      setIsEditable(false);
      setPaymentFormula({
        ...response?.data?.result,
      });
      setLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    setLoading("button");
    let response = await updateUserPaymentFormula(
      {
        type: paymentFormula.type,
        formulaDetails: paymentFormula?.formula_details,
      },
      paymentFormula?.id
    );
    if (response.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: response?.error?.response?.data?.message,
          severity: "error",
        };
      });
      setLoading(false);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: response?.data?.message,
          severity: "success",
        };
      });
      setPaymentFormula({
        ...paymentFormula,
      });
      setLoading(false);
      setIsEditable(false);
    }
  };

  useEffect(() => {
    getFormulaData();
  }, []);

  return (
    <>
      {loading === "main" ? (
        <div style={{ position: "relative", minHeight: "300px" }}>
          <div className="custom__table_tableloading">
            <CarrierInnerTableLoader />
          </div>
        </div>
      ) : (
        <>
          {paymentFormula === null ? (
            <>
              <div className="payment__formula_btn_wrapper">
                <div>
                  <button
                    className="payment__formula_btn"
                    onClick={() => createFormula()}
                  >
                    <MdAdd className="payment__formula_btnicon" size={18} />
                    {t("payments.createMarkup")}
                  </button>
                </div>
              </div>
              <div className="driver__screen_empty" style={{ width: "auto" }}>
                <div className="driver__scrnempt_content">
                  <Sad className="driver__scrnempt_contenticon" />
                  <div>{t("payments.noDefaultFormulaAvailableTo")}</div>
                </div>
              </div>
            </>
          ) : (
            <Form onSubmit={paymentFormula?.id ? handleUpdate : handleSave}>
              {isEditable === false && (
                <div className="payment__formula_btn_wrapper">
                  <div>
                    <button
                      className="payment__formula_btn"
                      onClick={() => setIsEditable(true)}
                    >
                      <MdAdd className="payment__formula_btnicon" size={18} />
                      {t("payments.updateMarkup")}
                    </button>
                  </div>
                </div>
              )}
              {/* {paymentFormula?.formula_details?.[0]?.value} */}
              <div className="payment__formula_formrow">
                <div className="payment__formula_formcol">
                  <TextFeild
                    Label={t("payments.serviceCharge")}
                    Name="value"
                    PlaceHolder="0"
                    Width="100%"
                    Adroment="%"
                    Data={paymentFormula?.formula_details?.[0]?.value ?? ""}
                    Handler={(e) => handleMarkup(e)}
                    Disabled={isEditable ? false : true}
                  />
                </div>
              </div>
              {isEditable === true && (
                <div className="prodidentifier__desc_modalfooter">
                  <button
                    className="prodidentifier__desc_modalcncl"
                    onClick={(e) => {
                      handleCancel(e);
                    }}
                  >
                    {t("common:actions.cancel")}
                  </button>

                  <button
                    type="submit"
                    className="prodidentifier__desc_modalsave"
                  >
                    {loading ? (
                      <Loader />
                    ) : paymentFormula?.id ? (
                      t("payments.update")
                    ) : (
                      t("common:actions.save")
                    )}
                  </button>
                </div>
              )}
            </Form>
          )}
        </>
      )}
    </>
  );
};

export default UserMarkup;
